<template>
  <v-container class="scrollable" ma-0 pa-0>
    <h4>{{$t('filter_date_range')}}</h4>
    <date-range-picker :dateRange="dateRange" @updated="setDateRange" :endUnlimited="true"
        :width="datePickerWidth" :vertical="true" :attach="true" :min-end="dateRange.startDate">
    </date-range-picker>
    <span v-if="dateRangeInvalid" class="caption text-red">{{$t('invalid_date_range')}}</span>
    <filter-component :filter-types="interactionFilterFields" :filter-change="filterChange" :filter-clear="filterClear"
                      :disabled="loading" style="padding-bottom: 136px"/>
  </v-container>
</template>

<script>
  import DateRangePicker from '../date/DateRangePicker'
  import { mapActions, mapMutations, mapState, mapGetters } from 'vuex'
  import { INTERACTIONS_DATE_FILTER_CHANGE } from '../../store/mutation-types'
  import {
    CHANGE_INTERACTIONS_FILTER,
    CLEAR_INTERACTIONS_FILTERS,
    GET_INTERACTIONS_LIST_START, GET_TUTOR_BOOLEAN
  } from '../../store/action-types'
  import FilterComponent from '../filter/FilterComponent'
  import { HAS_FEATURE_FLAG } from '../../store/getter-types'
  import moment from 'moment-es6'

  export default {
    name: 'interactions-filter',
    data () {
      return {
        dateRangeInvalid: false,
        dateRange: {
          startDate: moment().subtract(28, 'days').format('YYYY-MM-DD'),
          endDate: moment().format('YYYY-MM-DD')
        }
      }
    },
    computed: {
      ...mapGetters({
        hasFeatureFlag: HAS_FEATURE_FLAG
      }),
      ...mapState({
        filterFields: state => state.interactions.filterFields,
        loading: state => state.interactions.loading,
        moduleAlert: state => state.profile.module.alert,
        isTutor: state => state.profile.isTutor,
        functionInteractions: state => state.interactions.functions.interactions,
        optionEnableAlertFilter: state => state.interactions.options.enable.alertFilter
      }),
      datePickerWidth () {
        return this.$vuetify.breakpoint.smAndUp ? 250 : 265
      },
      interactionFilterFields () {
        if (!this.flagEnableAlertFilter) {
          delete this.filterFields.interactionTypes.values.ALERT
        }
        return this.filterFields
      },
      flagEnableAlertFilter () {
        return this.hasFeatureFlag(this.moduleAlert + '.' + this.functionInteractions + '.' + this.optionEnableAlertFilter)
      }
    },
    methods: {
      ...mapMutations({
        dateFilterChange: INTERACTIONS_DATE_FILTER_CHANGE
      }),
      ...mapActions({
        getInteractionsListStart: GET_INTERACTIONS_LIST_START,
        filterChange: CHANGE_INTERACTIONS_FILTER,
        filterClear: CLEAR_INTERACTIONS_FILTERS,
        checkTutorFlag: GET_TUTOR_BOOLEAN
      }),
      setDateRange (newDateRange) {
        let diff = moment(this.dateRange.endDate).diff(moment(this.dateRange.startDate), 'days')
        if (diff >= 0) {
          this.dateRangeInvalid = false
          this.dateFilterChange({
            startDate: newDateRange.startDate,
            endDate: newDateRange.endDate
          })
          this.getInteractionsListStart()
        } else {
          this.dateRangeInvalid = true
        }
      }
    },
    mounted () {
      if (!this.isTutor) {
        this.checkTutorFlag()
      }
    },
    components: {
      FilterComponent,
      DateRangePicker
    }
  }
</script>

<style scoped>
  .scrollable {
    max-height: calc(100vh - 160px);
    overflow-y: auto;

  }

  @media (max-width: 600px) {
    .scrollable {
      max-height: none;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/intervention/InteractionsFilter.vue